import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Hakkimda from "./sayfalar/Hakkimda";
import Egitimim from "./sayfalar/Egitimim";
import Portfolyom from "./sayfalar/Portfolyom";
import Tasarimlarim from "./sayfalar/Tasarimlarim";
import Iletisim from "./sayfalar/Iletisim";
import Blog from "./sayfalar/Blog";
import BlogDetail from "./sayfalar/BlogDetail";
import Bulunamadi from "./sayfalar/Bulunamadi";
import Takvim from "./sayfalar/Takvim";
import Gundemler from "./sayfalar/Gundemler";
import Navbar from "./bilesenler/Navbar";
import Footer from "./bilesenler/Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import NeonCanvas from "./kendintasarla/NeonCanvas";
import MugCanvas from "./kendintasarla/MugCanvas";
import KupaBardak from "./kendintasarla/KupaBardak";
import LedSignDesigner from "./kendintasarla/LedSignDesigner";
import YemekListesi from "./sayfalar/YemekListesi";
import Kampanya from "./sayfalar/Kampanya";
import SpinWheel from "./sinifaraclari/SpinWheel";
import Timer from "./sinifaraclari/Timer";
import Videolar from "./sinifaraclari/Videolar";
import Kisayollar from "./sayfalar/Kisayollar";
import Hatirlatici from "./sayfalar/Hatirlatici";
// DEĞİŞİKLİK 1: ClassroomTool yerine ProtectedClassroomTool import ediliyor.
import ProtectedClassroomTool from "./sayfalar/ProtectedClassroomTool";


const AppContent = () => {
  const location = useLocation();
  const isDesignCanvas = [
    "/neoncanvas",
    "/mugcanvas",
    "/kupabardak",
    "/ledsigndesigner",
    "/gundemler",
    "/classroomtool", // classroomtool'u da tam ekran kullanmak için ekleyelim.
  ].includes(location.pathname);

  // ProtectedClassroomTool'un navbar ve footer'ı olmaması için bu kontrolü güncelleyelim.
  const needsNavbarAndFooter = !isDesignCanvas;


  return (
    <div className="d-flex flex-column min-vh-100">
      {needsNavbarAndFooter && <Navbar />}
      <main className={`flex-grow-1 ${needsNavbarAndFooter ? "container mt-4" : ""}`}>
        <Routes>
          <Route path="/" element={<Hakkimda />} />
          <Route path="/egitimim" element={<Egitimim />} />
          <Route path="/portfolyom" element={<Portfolyom />} />
          <Route path="/tasarimlarim" element={<Tasarimlarim />} />
          <Route path="/iletisim" element={<Iletisim />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:canonicalUrl" element={<BlogDetail />} />
          <Route path="/neoncanvas" element={<NeonCanvas />} />
          <Route path="/mugcanvas" element={<MugCanvas />} />
          <Route path="/kupabardak" element={<KupaBardak />} />
          <Route path="/ledsigndesigner" element={<LedSignDesigner />} />
          <Route path="/takvim" element={<Takvim />} />
          <Route path="/gundemler" element={<Gundemler />} />
          <Route path="/kampanya" element={<Kampanya />} />
          <Route path="/yemeklistesi" element={<YemekListesi />} />
          <Route path="/spinwheel" element={<SpinWheel />} />
          <Route path="/timer" element={<Timer />} />
          <Route path="/videolar" element={<Videolar />} />
          <Route path="/kisayollar" element={<Kisayollar />} />
          <Route path="/hatirlatici" element={<Hatirlatici />} /> {/* YENİ EKLENEN SATIR */}
          <Route path="*" element={<Bulunamadi />} />
          {/* DEĞİŞİKLİK 2: Route'un elementi ProtectedClassroomTool olarak ayarlandı. */}
          <Route path="/classroomtool" element={<ProtectedClassroomTool />} />
        </Routes>
      </main>
      {needsNavbarAndFooter && <Footer />}
    </div>
  );
};

const App = () => (
  <HelmetProvider>
    <Router>
      <AppContent />
    </Router>
  </HelmetProvider>
);

export default App;
